import {ThunkAction} from "redux-thunk";
import {AppStateType, InferActionsTypes} from "./store";
import {CouponType, ResultCodesEnum, ShopTypes} from "./types";
import {commonAsyncHandler} from "./common-async-handler";
import {shopAPI} from "../dal/shops-api";

export enum RequestStatuses { None = 0, InProgress = 1, Success = 2, Error = 3 }

const initState = {
    requestStatus: RequestStatuses.None,
    errorMessage: '',
    shops: [] as ShopTypes[],
    currentShop: null as ShopTypes | null,
    coupons: [] as CouponType[]
}

type StateType = typeof initState

export type AppActionsTypes = InferActionsTypes<typeof appActions>

type ThunkActionType = ThunkAction<Promise<void>, AppStateType, unknown, AppActionsTypes>

export const AppReducer = (state = initState, action: AppActionsTypes): StateType => {
    switch (action.type) {
        case "APP_REDUCER/SET_REQUEST_STATUS":
            return {
                ...state,
                requestStatus: action.status
            }
        case "APP_REDUCER/SET_ERROR_MESSAGE":
            return {
                ...state,
                errorMessage: action.errorMessage
            }
        case "APP_REDUCER/SET_SHOPS":
            return {
                ...state,
                shops: action.shops
            }
        case "APP_REDUCER/SET_SHOP":
            return {
                ...state,
                currentShop: action.shop
            }
        case "APP_REDUCER/SET_COUPONS":
            return {
                ...state,
                coupons: action.coupons
            }
        default:
            return state
    }
}

export const appActions = {
    setRequestStatus: (status: RequestStatuses) => ({type: 'APP_REDUCER/SET_REQUEST_STATUS', status}) as const,
    setErrorMessage: (errorMessage: string) => ({
        type: 'APP_REDUCER/SET_ERROR_MESSAGE',
        errorMessage
    }) as const,
    setShops: (shops: ShopTypes[]) => ({type: 'APP_REDUCER/SET_SHOPS', shops}) as const,
    setShop: (shop: ShopTypes) => ({type: 'APP_REDUCER/SET_SHOP', shop}) as const,
    setCoupns: (coupons: CouponType[]) => ({type: 'APP_REDUCER/SET_COUPONS', coupons}) as const,
}


export const getShops = (): ThunkActionType => async (dispatch) => {
    await commonAsyncHandler(async () => {
        const response = await shopAPI.getShops()
        const shops = response.map(r => ({...r, products: [{rating: 3}]})) as ShopTypes[]
        // if(response.resultCode === ResultCodesEnum.Success){
        dispatch(appActions.setShops(shops))
        // } else {
        //     dispatch(appActions.setRequestStatus(RequestStatuses.Error))
        //     dispatch(appActions.setErrorMessage(response.messages[0]))
        // }
        return response
    }, dispatch)
}

export const getShopById = (shopId: number): ThunkActionType => async (dispatch) => {
    await commonAsyncHandler(async () => {
        const data = await shopAPI.getShopById(shopId)
        dispatch(appActions.setShop(data))
        return data
    }, dispatch)
}

export const getCouponsByShopId = (shopId: number): ThunkActionType => async (dispatch) => {
    await commonAsyncHandler(async () => {
        const data = await shopAPI.getCouponsByShopId(shopId)
        dispatch(appActions.setCoupns(data))
        return data
    }, dispatch)
}



